import { Controller } from '@hotwired/stimulus'
import FlashController from './flash_controller'

export default class PairShelterController extends Controller {
  static values = { currentStep: Number }
  static targets = [
    'form',
    'stepContent',
    'stepLoader',
    'prevButton',
    'nextButton',
    'resetButton',
    'skipGdsCck'
  ];

  showLoader (e) {
    this.stepContentTarget.classList.add('hidden')
    this.stepLoaderTarget.classList.remove('hidden')
    this.prevButtonTarget.disabled = true
    this.nextButtonTarget.disabled = true
    this.nextButtonTarget.classList.add('!text-gray-400')

    if (e && e.currentTarget) {
      const form = e.currentTarget.closest('form')
      form.requestSubmit()
    }
  }

  addFormAction (action) {
    const extraInput = document.createElement('input')
    extraInput.type = 'hidden'
    extraInput.name = action
    extraInput.value = true
    this.formTarget.appendChild(extraInput)
  }

  skipGds (e) {
    const chk = e.target
    if (chk.checked) {
      const els = document.querySelectorAll('input[name^="pair_gds["]')
      els.forEach(e => {
        e.disabled = true
        e.required = false
      })
      this.gdsSkipped = true
    } else {
      const els = document.querySelectorAll('input[name^="pair_gds["]')
      els.forEach(e => {
        e.disabled = false
        e.required = true
      })
      this.gdsSkipped = false
    }
  }

  toggleShelter2Field (e) {
    const chk = e.target
    const shelter2Field = document.getElementById('shelter_2_field')
    const shelter2Input = document.querySelector('input[name="combo_shelters[shelter_2_asset_tag_label]"]')

    if (chk.checked) {
      if (shelter2Field) {
        shelter2Field.style.display = 'none'
      }
      if (shelter2Input) {
        shelter2Input.disabled = true
        shelter2Input.required = false
        shelter2Input.value = ''
      }
    } else {
      if (shelter2Field) {
        shelter2Field.style.display = 'block'
      }
      if (shelter2Input) {
        shelter2Input.disabled = false
        shelter2Input.required = false
      }
    }
  }

  submitForm (e) {
    if (!this.hasFormTarget) {
      return
    }

    const navAction = e.currentTarget.dataset.navAction
    console.log(navAction)

    if (navAction === 'next') {
      if (this.formTarget.checkValidity()) {
        const formAction = this.formTarget.action
        const url = new URL(formAction)
        const params = new URLSearchParams(url.search)
        const currentStepKey = params.get('current_step_key')

        if (currentStepKey === 'pair') {
          FlashController.prototype.renderFlash('Shelter pairing processing.', 'success')
        }

        if (this.gdsSkipped) {
          if (!confirm('GDS data entry is required for all shelters except Urban Panels. Are you sure you wish to continue?')) { return }
        }

        this.showLoader()
        this.formTarget.requestSubmit()
      } else {
        this.formTarget.reportValidity()
      }
    } else if (navAction === 'reset') {
      this.formTarget.noValidate = true
      this.addFormAction('reset')
      this.showLoader()
      this.formTarget.requestSubmit()
    } else if (navAction === 'check_devices') {
      this.formTarget.noValidate = true
      this.addFormAction('check_devices')
      this.showLoader()
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.noValidate = true
      this.addFormAction('nav_back')

      this.showLoader()
      this.formTarget.requestSubmit()
    }
  }
}
